<template>
  <div class="record-container">
    <img
      class="toast-bg"
      src="https://btw-common-data.betterwestar.com/btw-admin/resource/b30bf287f0ecd9587180b3370a972c36_wh=1125_870.png"
      alt=""
    />
    <img
      class="title-image"
      src="https://btw-common-data.betterwestar.com/btw-admin/resource/40ee9f2bec4d53d965118b5dc37fb30a_wh=471_186.png"
      alt=""
    />
    <div class="close" @click="bindClose"
      ><span class="iconfont icon-cha"></span
    ></div>
    <div class="record-flex">
      <div class="record-scroll">
        <div class="record-list" v-if="recordList">
          <div
            class="record-item"
            v-for="(item, index) in recordList"
            :key="index"
          >
            <div class="avatar-container">
              <img class="avatar" :src="item.coach_image" alt="" />
              <!--  <div class="main">主教练</div> -->
            </div>
            <div class="item-center">
              <div class="item-truename">{{ item.coach_name }}</div>
              <div class="item-store">{{ item.store_name }}</div>
            </div>
            <div class="flower-info">
              <img
                class="flower-image"
                src="https://btw-common-data.betterwestar.com/btw-admin/resource/71ba3142596f4cf6b18e50e08fa3ca17_wh=66_66.png"
                alt=""
              />
              <div class="flower-num">{{ item.gift_num }}</div>
            </div>
          </div>
          <div class="empty" v-if="!recordList.length">暂无送花记录</div>
        </div>
        <div class="space"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      recordList: null
    }
  },
  watch: {
    show() {
      if (this.show) {
        this.getRecord()
      }
    }
  },
  created() {
    this.getRecord()
  },
  methods: {
    bindClose() {
      this.$emit('close')
    },
    async getRecord() {
      let res = await this.$http
        .getApp('api/v1/AnnualCoach/getGiveRedFlowerRecord')
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.recordList = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.record-container {
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  background: linear-gradient(178deg, #ffc0dc 0%, #fff3f8 100%);
  border-radius: 8px 8px 0px 0px;
  padding: 94px 12px 0px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .toast-bg {
    z-index: -1;
    width: 100%;
    left: 0;
    top: -26px;
    position: absolute;
  }
  .title-image {
    z-index: -1;
    width: 157px;
    left: 20px;
    top: 20px;
    position: absolute;
  }
  .tips {
    margin-top: 53px;
    margin-bottom: 9px;
    font-weight: bold;
    font-size: 12px;
    color: rgba(48, 48, 56, 0.78);
    line-height: 18px;
  }
  .record-scroll {
    min-height: 282px;
    max-height: 450px;
    background: #ffffff;
    border-radius: 8px 8px 0px 0px;
    overflow-y: scroll;
  }
  .record-flex {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }
  .record-list {
    border-radius: 8px;
    padding: 20px 16px;
    .record-item {
      display: flex;
      align-items: center;
      margin-bottom: 31px;

      .avatar-container {
        position: relative;
        width: 44px;
        height: 44px;
        object-fit: cover;
        margin-right: 10px;
        .avatar {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          overflow: hidden;
          object-fit: cover;
        }
        .main {
          white-space: nowrap;
          padding: 0px 7px;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translate(-50%, 0%);
          height: 15px;
          box-sizing: border-box;
          background: #f64372;
          border-radius: 8px;
          border: 1px solid #ffffff;
          font-weight: bold;
          font-size: 10px;
          line-height: 13px;
          color: #ffffff;
        }
      }
      .item-center {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        .item-truename {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-weight: bold;
          font-size: 16px;
          color: #050b27;
          line-height: 22px;
          margin-bottom: 6px;
        }
        .item-store {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 12px;
          color: rgba(48, 48, 56, 0.5);
          line-height: 16px;
        }
      }
      .flower-info {
        display: flex;
        align-items: center;
        .flower-image {
          width: 16px;
          height: 16px;
          object-fit: contain;
          margin-right: 4px;
        }
        .flower-num {
          font-family: DIN;
          font-weight: bold;
          font-size: 20px;
          color: #ff2270;
          line-height: 26px;
        }
      }
    }
    .record-item:last-child {
      margin-bottom: 0;
    }
    .empty {
      margin-top: 100px;
      margin-bottom: 100px;
      text-align: center;
    }
  }
  .space {
    height: 30px;
  }
  .close {
    position: absolute;
    right: 15px;
    top: 15px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    .iconfont {
      font-weight: bold;
      font-size: 20px;
      color: rgba(48, 48, 56, 1);
    }
  }
}
</style>
